import { graphql, HttpResponse } from 'msw'
import { type EnrollmentHYCSSettingUpData, type EnrollmentHYCSSettingUpSubmitOutput } from '../../../../models'

export const getEnrollmentHYCSSettingUpDataMock: EnrollmentHYCSSettingUpData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/setting-up',
}

export const submitEnrollmentHYCSSettingUpDataMock: EnrollmentHYCSSettingUpSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/document-verification',
}

export const mockGetEnrollmentHYCSSettingUpData = graphql.mutation('getEnrollmentHYCSSettingUpData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentHYCSSettingUpDataMock } })
})

export const mockSubmitEnrollmentHYCSSettingUpData = graphql.mutation('submitEnrollmentHYCSSettingUpData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentHYCSSettingUpDataMock } })
})

export const mockEnrollmentHYCSSettingUp = [mockGetEnrollmentHYCSSettingUpData, mockSubmitEnrollmentHYCSSettingUpData]
